module.exports = "/images/vessel-9.jpg";